import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type TitleType = "title" | "pro" | "contra";

export type TitleState = {
    [key in TitleType]: string;
}
const searchParams = new URLSearchParams(window.location.hash.split("?", 2).at(1) ?? "?");

export const titleSlice = createSlice({
    name: "titles",
    initialState: {
        title: searchParams.get("title") || "Argumentationswippe",
        pro: searchParams.get("pro") || "Pro",
        contra: searchParams.get("contra") || "Contra",
    } as TitleState,
    reducers: {
        setTitle(state, action: PayloadAction<{ field: TitleType, text: string }>) {
            state[action.payload.field] = action.payload.text;
        }
    }
});

export const { setTitle } = titleSlice.actions;
